import React, { useEffect, useMemo, useRef, useState } from "react"
import * as Yup from "yup"
import {
  Col,
  Container,
  Row,
  CardTitle,
  Label,
  Input,
  Button,
  Form,
  Spinner,
} from "reactstrap"
import Select, { components } from "react-select"
import file from "../../assets/images/icons/file-type.svg"
import editIcon from "../../assets/images/icons/edit.svg"
import {
  checkExtension,
  formatAmount,
  renderAddressValue as renderCommunicationAddress,
  showRegistrationType,
} from "helpers/common"
import { Link, useNavigate } from "react-router-dom"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import imageIcon from "../../assets/images/icons/image.svg"
import {
  useKycFinalSubmissionMutation,
  useUpdateKycStepMutation,
} from "store/api/kyc/kyc"
import { useDispatch, useSelector } from "react-redux"
import { setLoginUserData } from "store/slices/userSlice"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"

import ArrowDown from "../../assets/images/icons/ArrowDown.svg"

const CustomDropdownIndicator = (props) => {
  const { isDisabled } = props.selectProps

  return (
    <components.DropdownIndicator {...props}>
      {!isDisabled ? <img className="cp" src={ArrowDown} alt="" /> : <></>}
    </components.DropdownIndicator>
  )
}
const KycFinalStepBusiness = ({ kycData }) => {
  const [kycFinalSubmission, { isLoading }] = useKycFinalSubmissionMutation()
  const { user } = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [updateStep] = useUpdateKycStepMutation()

  const goToStep = async (step) => {
    try {
      await updateStep({ kyc_status: step }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  const submitForVerification = async () => {
    try {
      const { message, success } = await kycFinalSubmission({
        entity_type: kycData.entity_type,
        kycStep: kycData.status,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        dispatch(
          setLoginUserData({
            user: { ...user, kyc_status: "SUBMITTED" },
          })
        )
        navigate("/")
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const businessFiles = [
    { key: "initial_partnership_deed", label: "Initial Partnership Deed" },
    { key: "latest_partnership_deed", label: "Latest Partnership Deed" },
    {
      key: "certificate_of_incorporation",
      label: "Certificate of Incorporation",
    },
    { key: "gstin_certificate", label: "GSTIN Certificate" },
    { key: "memorandum_of_association", label: "Memorandum of Association" },
    { key: "articles_of_association", label: "Articles of Association" },
    { key: "initial_llp_deed", label: "Initial LLP Deed" },
    { key: "latest_llp_deed", label: "Latest LLP Deed" },
    { key: "huf_creation_document", label: "HUF Creation Document" },
    { key: "trust_deed", label: "Trust Deed" },
    { key: "society_bye_laws", label: "Society Bye-laws" },
  ]

  const defaultAddressValues = useMemo(
    () => ({
      business_address: kycData?.investorCompanyDetails?.business_address || "",
      address_one: kycData?.investorCompanyDetails?.address_one || "",
      address_two: kycData?.investorCompanyDetails?.address_two || "",
      address_three: kycData?.investorCompanyDetails?.address_three || "",
      city: kycData?.investorCompanyDetails?.city || "",
      state: kycData?.investorCompanyDetails?.state || "",
      pin_code: kycData?.investorCompanyDetails?.pin_code || "",
    }),
    [kycData]
  )

  const renderAddressValue = () => {
    if (kycData?.investorCompanyDetails?.business_address) {
      return kycData?.investorCompanyDetails?.business_address
    } else {
      let address = ""
      const addressOne = kycData?.investorCompanyDetails?.address_one
      const addressTwo = kycData?.investorCompanyDetails?.address_two
      const addressThree = kycData?.investorCompanyDetails?.address_three
      const city = kycData?.investorCompanyDetails?.city
      const state = kycData?.investorCompanyDetails?.state
      const pinCode = kycData?.investorCompanyDetails?.pin_code

      if (addressOne) {
        address = address.concat(addressOne, " ")
      }
      if (addressTwo) {
        address = address.concat(addressTwo, " ")
      }
      if (addressThree) {
        address = address.concat(addressThree, " ")
      }
      if (city) {
        address = address.concat(city, " ")
      }
      if (state) {
        address = address.concat(state, " ")
      }
      if (pinCode) {
        address = address.concat(pinCode)
      }

      return address
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          marginTop: "6rem",
          paddingInline: "2rem",
        }}
      >
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mt-4 mb-4 justify-content-between">
                  <CardTitle className="">Entity Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Name of the Entity</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.investorCompanyDetails?.entity_name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Date of Incorporation
                    </Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.investorCompanyDetails?.date_of_incorporation
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Constitution of Business
                    </Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.investorCompanyDetails
                          ?.constitution_of_business
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Registered Address</Label>
                    <Input
                      disabled
                      name="name"
                      type="textarea"
                      className="form-control"
                      value={renderAddressValue()}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Communication Address
                    </Label>
                    <Input
                      disabled
                      name="name"
                      type="textarea"
                      className="form-control"
                      value={
                        kycData?.investorCompanyDetails
                          ?.is_comm_address_same === "SAME"
                          ? renderAddressValue()
                          : renderCommunicationAddress(
                              kycData?.investorCompanyDetails
                                ?.communication_address
                            )
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">PAN</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.pan_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">GSTIN</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.investorCompanyDetails?.gstin ||
                        "Not Applicable"
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Phone No.</Label>
                    <Input
                      disabled
                      name="phone"
                      type="text"
                      className="form-control"
                      value={kycData?.phone}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Email Address</Label>
                    <Input
                      disabled
                      name="email"
                      type="text"
                      className="form-control"
                      value={kycData?.email}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Political Exposure</Label>
                    <Input
                      disabled
                      name="politicalExposure"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.businessAdditionalDetails?.politicalExposure
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Entity Registration No.(
                      {showRegistrationType(
                        kycData?.businessAdditionalDetails
                          ?.constitution_of_business
                      )}
                      )
                    </Label>
                    <Input
                      disabled
                      name="email"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.businessAdditionalDetails
                          ?.entity_registration_no
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Bank Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Account Holders Name
                    </Label>
                    <Input
                      disabled
                      name="account_holder"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.account_holder}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Number</Label>
                    <Input
                      disabled
                      name="account_no"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.account_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Bank Name</Label>
                    <Input
                      disabled
                      name="bank_name"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.bank_name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">IFSC</Label>
                    <Input
                      disabled
                      name="ifsc"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.ifsc}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Type</Label>
                    <Input
                      disabled
                      name="account_type"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.account_type}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {kycData?.investorsDematDetails && (
          <Row>
            <Col xl={12}>
              <div>
                <div>
                  <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                    <CardTitle className="">Demat Details</CardTitle>
                  </div>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Demat Account Number
                      </Label>
                      <div className="input-wrapper">
                        <Input
                          disabled
                          name="demat_account_no"
                          type="text"
                          className="form-control"
                          value={
                            kycData?.investorsDematDetails.demat_account_no
                          }
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Depository Participant Name
                      </Label>
                      <Input
                        disabled
                        name="depository_participant_name"
                        type="text"
                        className="form-control"
                        value={
                          kycData?.investorsDematDetails
                            .depository_participant_name
                        }
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Depository Name</Label>
                      <div className="input-wrapper">
                        <Input
                          name="exchange_type"
                          type="text"
                          className="form-control"
                          disabled
                          value={kycData?.investorsDematDetails?.exchange_type}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Authorised Person Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Name</Label>
                    <Input
                      disabled
                      name="demat_account_no"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsAadhaar?.name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Date of Birth</Label>
                    <Input
                      disabled
                      name="depository_participant_name"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsAadhaar?.dob}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">PAN</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsPAN?.pan}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Aadhaar No.</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsAadhaar?.aadhaar_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Designation</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={kycData?.businessAdditionalDetails?.designation}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">DIN</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.businessAdditionalDetails?.dpin ??
                        "Not Applicable"
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          {kycData?.icdAgreements.length > 0 && (
            <Row>
              <Col xl={12}>
                <div>
                  <div>
                    <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                      <CardTitle className="">ICD Details</CardTitle>
                    </div>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          ICD Tenure (in Months)
                        </Label>
                        <Input
                          disabled
                          name="account_holder"
                          type="text"
                          className="form-control"
                          value={kycData?.icdAgreements[0].tenure}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Proposed ICD Amount
                        </Label>
                        <Input
                          disabled
                          name="account_no"
                          type="text"
                          className="form-control"
                          value={`₹ ${formatAmount(
                            kycData?.icdAgreements[0].amount
                          )}`}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Row>

        <Row>
          <Col xl={12}>
            <CardTitle className="mt-4 mb-4">Documents</CardTitle>

            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Entity Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.investorCompanyDetails?.pan_image && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.investorCompanyDetails.pan_image_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>PAN</p>
                      <Link
                        to={kycData?.investorCompanyDetails.pan_image_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
              {businessFiles.map((item, index) => (
                <React.Fragment key={`businessFiles_${index}`}>
                  {kycData?.businessAdditionalDetails?.[item.key] && (
                    <div className="documents-box">
                      <div className="file-type">
                        {checkExtension(
                          kycData?.businessAdditionalDetails?.[item.key]
                        ) === "pdf" ? (
                          <img src={pdfIcon} alt="" />
                        ) : (
                          <img src={imageIcon} alt="" />
                        )}

                        <div>
                          <p>{item.label}</p>
                          <Link
                            to={
                              kycData?.businessAdditionalDetails?.[
                                `${item.key}_url`
                              ]
                            }
                            target="_blank"
                          >
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="verified-user">
                          <img src={check} alt="" /> Verified
                        </div> */}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <hr className="my-4" />
            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Authorised Person Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.investorsAadhaar?.aadhaar_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.investorsAadhaar.aadhaar_file_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Aadhaar</p>
                      <Link
                        to={kycData?.investorsAadhaar.aadhaar_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}

              {kycData?.avatar_url && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(kycData?.avatar_url) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Selfie</p>
                      <Link to={kycData?.avatar_url} target="_blank">
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {kycData?.investorsPAN?.pan_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(kycData?.investorsPAN?.pan_file_url) ===
                    "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>PAN</p>
                      <Link
                        to={kycData?.investorsPAN?.pan_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {kycData?.businessAdditionalDetails?.authority_letter && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.businessAdditionalDetails?.authority_letter_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Authority Letter</p>
                      <Link
                        to={
                          kycData?.businessAdditionalDetails
                            ?.authority_letter_url
                        }
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
            </div>

            <hr className="my-4" />
            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Banking Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.investorsDematDetails?.cml_report && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.investorsDematDetails?.cml_report_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>CML Report</p>
                      <Link
                        to={kycData?.investorsDematDetails.cml_report_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {kycData?.investorsBankDetails?.cheque_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.investorsBankDetails.cheque_file_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Cheque</p>
                      <Link
                        to={kycData?.investorsBankDetails.cheque_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
            </div>
            <div className="buttons">
              {/* {user?.kyc_status === "KYC_PENDING" && (
                  <button
                    type="button"
                    onClick={() => goToStep("AGREEMENT_DETAILS")}
                    disabled={isLoading}
                    className="btn btn-primary prev-button"
                  >
                    {"Previous Page"}
                  </button>
                )} */}
              <Button
                type="button"
                className="btn btn-primary w-md"
                disabled={isLoading}
                onClick={() => submitForVerification()}
              >
                {isLoading ? <Spinners /> : "Submit for Verification"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default KycFinalStepBusiness
